// @ts-nocheck
import { useContext, useMemo, useState } from 'react';
import { IChangeTaskPhaseConfirmationParameters } from '../models/ConfirmationModalParameters';
import { LocalizationEntity } from '../../shared/models/localization';
import LocalizationContext from '../../shared/contexts/LocalizationContext';
import LocalizationHelper from '../../helpers/TranslationHelper';

//hook logic here to reduce size of main Kanban component
export const useChangeTaskPhaseConfirmDialog = () => {
  const localization = useContext<Array<LocalizationEntity>>(LocalizationContext);
  const localizedParams: IChangeTaskPhaseConfirmationParameters = useMemo(
    () => ({
      headerPlaceholder: LocalizationHelper.getLocaleEntityValue(
        localization,
        'ZSite.Frontend.Kanban.Modals.TaskPhaseChange.Header',
        'Release Estimate'
      ),
      confirmButtonPlaceholder: LocalizationHelper.getLocaleEntityValue(
        localization,
        'ZSite.Frontend.Kanban.Modals.TaskPhaseChange.ConfirmButton',
        'Confirm'
      ),
      cancelButtonPlaceholder: LocalizationHelper.getLocaleEntityValue(
        localization,
        'ZSite.Frontend.Kanban.Modals.TaskPhaseChange.CancelButton',
        'Cancel'
      ),
      validationErrorMessage: LocalizationHelper.getLocaleEntityValue(
        localization,
        'ZSite.Frontend.Kanban.Modals.TaskPhaseChange.ValidateError',
        'Estimation must be greater than 0'
      ),
    }),
    [localization]
  );

  const [showConfirmTaskPhaseChangeDialog, setShowConfirmTaskPhaseChangeDialog] = useState<{
    isOpen: boolean;
    modalParameters?: IChangeTaskPhaseConfirmationParameters;
    onConfirm?: (result: number) => void;
    onCancel?: () => void;
    onClose?: () => void;
  }>({ isOpen: false });

  const showConfirmDialog = (taskId: string, isReleaseEstimation: boolean): Promise<any> => {
    const params = {
      ...localizedParams,
      taskId: Number(taskId),
      isReleaseEstimation,
      textPlaceholder: isReleaseEstimation
        ? LocalizationHelper.getLocaleEntityValue(
            localization,
            'ZSite.Frontend.Kanban.Modals.TaskPhaseChange.ReleaseEstimText'
          )
        : LocalizationHelper.getLocaleEntityValue(
            localization,
            'ZSite.Frontend.Kanban.Modals.TaskPhaseChange.EstimText'
          ),
    };

    return new Promise((resolve) => {
      setShowConfirmTaskPhaseChangeDialog({
        isOpen: true,
        modalParameters: params,
        onConfirm: (result: number) => {
          setShowConfirmTaskPhaseChangeDialog({ isOpen: false });
          resolve({
            taskId: Number(taskId),
            estimation: result,
            isReleaseEstimation,
            success: true,
          });
        },
        onCancel: () => {
          setShowConfirmTaskPhaseChangeDialog({ isOpen: false });
          resolve({ success: false });
        },
        onClose: () => {
          setShowConfirmTaskPhaseChangeDialog({ isOpen: false });
          resolve({ success: false });
        },
      });
    });
  };

  return {
    showConfirmDialog,
    showConfirmTaskPhaseChangeDialog,
    setShowConfirmTaskPhaseChangeDialog,
  };
};
